
import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { isEmpty } from "lodash";

import { getCommModelSortComparator } from "utils/directory/sorting";

import Loading from "components/Loading";
import Card from "components/Card";
import Button from "components/Button";
import { AddModelDialog } from "components/Dashboard/Actions";
import DashboardTable from "components/Dashboard/Table";
import WeatherLocationInfo from "./WeatherLocationInfo";

import classes from "../style.module.scss";

const CustomModels = ({
    history,
    commModelDir = {},
    change,
}) => {
    const modelRef = useRef(null);
    const scrollContainerRef = useRef(null);

    /* Loading state and cursor position for loading spinner */
    const [cursorPosition, setCursorPosition] = useState({ top: 0, left: 0 });
    const [isLoading, setIsLoading] = useState(false);

    /* All community models */
    const [allModels, setAllModels] = useState([]);
    const [toAddModel, setToAddModel] = useState(false);
    const [sortBy, setSortBy] = useState("name");
    const [sortOrder, setSortOrder] = useState("asc");

    // Get cursor position for loading spinner
    const onMouseMove = useCallback((e) => {
        const top = e.pageY - window.scrollY + 10;
        const left = e.pageX - window.scrollX + 10;

        setCursorPosition({ top, left });
    }, []);

    // Update loading spinner location when cursor moves
    useEffect(() => {
        const handleMouseMove = (e) => {
            onMouseMove(e);
        };

        if (!isLoading) return;

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("wheel", handleMouseMove);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("wheel", handleMouseMove);
        };
    }, [isLoading, onMouseMove]);

    // Get sorted list of commModels
    useEffect(() => {
        const { models: singleModels = {} } = commModelDir;
        const allModels = !isEmpty(singleModels)
            ? Object.entries(singleModels)
                .map(([key, el]) => [key, { ...el, type: "commModel" }])
                .sort(getCommModelSortComparator(sortBy, sortOrder))
            : [];
        setAllModels(allModels);
    }, [commModelDir, sortBy, sortOrder]);

    return (
        <div
            className={classes.contentContainer}
            onMouseMove={onMouseMove}
            style={{ pointerEvents: isLoading ? "none" : "auto" }}
            ref={scrollContainerRef}
        >
            <div style={{ position: "fixed", pointerEvents: "none", ...cursorPosition }}>
                {isLoading && <Loading className={classes.smallerSpinner} subClassName={classes.smallSpinner} />}
            </div>

            <h2 className={classes.title}>
                House Models
            </h2>
            <DashboardTable
                // folderItemRef={modelRef}
                history={history}
                dirType={"commModelDir"}
                allFoldersItems={allModels}
                itemType={"commModel"}
                setIsLoading={setIsLoading}
                paginate
                defaultRowsPerPage={5}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                allowMultiSelect
                sortData={{ sortBy, setSortBy, sortOrder, setSortOrder }}
            />
            {isEmpty(allModels) && (
                <Card className={classes.firstHouseModel}>
                    <Button onClick={() => setToAddModel(true)} >
                        Add your first house model
                    </Button>
                    <AddModelDialog
                        addModelOpen={toAddModel}
                        onClose={() => setToAddModel(false)}
                    />
                </Card>
            )}

            <WeatherLocationInfo change={change} />
        </div>
    );
}

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CustomModels);